<template>
  <div id="app" v-bind:class="classObject">
    <!-- ////////////// App Start ////////////// -->
    <transition name="fade">
      <router-view></router-view>
    </transition>
    <!-- ////////////// App End ////////////// -->
  </div>
</template>



<script>
  import IndexDisplay from '@/common/lib/IndexDisplay'
  import ComposeDisplay from '@/common/lib/ComposeDisplay'
  export default {
    data () {
      return {
        routePath: IndexDisplay(this.$route.path, process.env.APP_NAME),
        windowWidth: 0
      }
    },
    name: 'app',
    mounted: function () {
      // this.setHeaderFullHeight()
      // window.addEventListener('resize', this.setHeaderFullHeight, false)
    },
    methods: {
      // setHeaderFullHeight: function () {
      //   // console.log('SINE', parseInt(Math.sin(1.5 / 180 * Math.PI) * window.innerWidth))
      //   var headerFullHeight = parseInt(Math.sin(1.5 / 180 * Math.PI) * window.innerWidth) + 82
      //   if (document.querySelector('.side-info')) {
      //     document.querySelector('.side-info').style.paddingTop = (headerFullHeight + 30) + 'px'
      //     document.querySelector('.main').style.paddingTop = headerFullHeight + 'px'
      //     return true
      //   }
      //   return false
      // }
    },
    computed: {
      classObject: function () {
        return {
          indexBackground: !IndexDisplay(this.$route.path, process.env.APP_NAME),
          composeMesage: !ComposeDisplay(this.$route.path, process.env.APP_NAME)
        }
      }
    }
  }
</script>


<style>

  /* ////////////////////////////////////// */
  /* Start Font Face */

  @import url("/static/css/fonts.css");
  @import url("/static/css/open-sans/open-sans.css");
  /* @import url("/static/css/dragula.css"); */

  /* End Font Face */
  /* ////////////////////////////////////// */

  /* fichier référençant les couleurs */
  @import url("/static/css/colors.css");;


  .navbar-svg path {
    fill: var(--secondary-color);
  }

  #top-right-hand-corner {
    -ms-transform: rotate(1.5deg); /* IE 9 */
    -webkit-transform: rotate(1.5deg); /* Safari */
    transform: rotate(1.5deg);
    position: absolute;
    text-align: right;
    right: 11px;
    top: 96px;
    color: var(--secondary-color);
  }

  #user-stuff {
    position: absolute;
    right: 166px;
    width: 25vw;
    text-align: right;
  }

  #user-identity {
    display: inline-block;
    position: relative;
    text-align: left;
    font-family: 'Open Sans', Arial;
    font-weight: 400;
    font-size: 16px;
    white-space: nowrap;
    top: -2px;
    right: 40px;
    padding-left: 85px;
    padding-top: 15px;
    height: 80px;
    background: url(/static/images/font_user.svg) no-repeat;
    background-position: 0 12px;
    background-size: 52px 52px;
  }

  #user-identity .nav-link {
    color: var(--secondary-color);
    text-decoration: underline;
  }

  #nav-buttons {
    width: 166px;
    height: 80px;
    position: relative;
    display: inline-block;
    margin-left: 30px;
    background: url(/static/images/nav-buttons.png) no-repeat;
    top: -4px;
  }

  #log-out-button {
    right: 0;
    top: 0;
  }

  #log-out-button svg {
    fill: var(--primary-color);
    margin-right: 20px;
    margin-top: 23px;
    width: 37px;
    height: 26px;
  }

  #log-out-button:hover svg {
    fill: var(--secondary-color);
  }

  #home-button {
    right: 0;
    top: 0;
  }

  #home-button svg {
    fill: var(--primary-color);
    margin-right: 17px;
    margin-top: 15px;
    width: 43px;
    height: 41px;
  }

  #home-button:hover svg {
    fill: var(--secondary-color);
  }

  .navbar-svg-buttons {
    position: absolute;
    width: 70px;
    height: 70px;
  }

  .navbar-fixed-top {
    z-index: 1000;
  }

  /* ------------- */

  .info-box.fullOpacity, .error-box.fullOpacity, .refuse-box.fullOpacity {
    opacity: 1;
    top: calc((100vh / (1080 / 158)) * -1);
  }

  /* ------------- */

  .info-box {
    transition: opacity 0.8s ease;
    background: url(/static/images/info_msg.svg) top center no-repeat;
    /*width: 667px;*/
    width: calc(100vh / (949 / 667));
    /*height: 103px;*/
    height: calc(100vh / (949 / 103));
    left: calc(50% - (100vh / (949 / 667) / 2));
    text-align: left;
    position: absolute;
    top: -10000px;
    opacity: 0;
  }

  .info-box-main {
    background: url(/static/images/info_msg.svg) center 10px no-repeat;
    /*width: 667px;*/
    width: calc(85vh / (949 / 667));
    /*height: 113px;*/
    height: calc(85vh / (949 / 125));
    text-align: left;
    margin: auto;
    text-align: left;
    position: relative;
  }

  .info-box-main-home {
    background: url(/static/images/info_msg.svg) center 10px no-repeat;
    background-position: cover;
    width: calc(85vh / (949 / 720));
    height: calc(85vh / (949 / 140));
    text-align: left;
    margin: auto;
    position: relative;
  }

  .info-text {
    text-align: center;
    color: var(--info-primary-color);
    font-family: 'Open Sans', Arial;
    font-weight: 400;
    /*font-size: 14px;*/
    font-size: calc(100vh / (949 / 16));
    display: inline-block;
    position: relative;
    /*width: 498px;*/
    width: calc(100vh / (949 / 498));
    /*height: 45px;*/
    height: calc(100vh / (949 / 45));
    top: calc(45% - ((100vh / (949 / 45)) / 2));
    left: calc(50% - ((100vh / (949 / 498)) / 2));
  }

  .info-text-main {
    /*width: 667px;*/
    width: calc(85vh / (949 / 667));
    /*height: 113px;*/
    height: calc(85vh / (949 / 113));
    text-align: center;
    color: var(--info-primary-color);
    font-family: 'Open Sans', Arial;
    font-weight: 400;
    /*font-size: 10px;*/
    font-size: calc(85vh / (949 / 16));
    display: table-cell;
    vertical-align: middle;
  }

  .info-text-main-home {
    /*width: 667px;*/
    width: calc(85vh / (949 / 667));
    /*height: 113px;*/
    height: calc(85vh / (949 / 113));
    text-align: center;
    color: var(--info-primary-color);
    font-family: 'Open Sans', Arial;
    font-weight: 400;
    /*font-size: 14px;*/
    font-size: calc(85vh / (949 / 16));
    display: table-cell;
    vertical-align: middle;
    /*padding-left: 45px;*/
    padding-left: calc(85vh / (949 / 45));
  }


  .info-box-icon {
    stroke: none;
    fill: var(--info-primary-color);
    /*height: 30px; */
    height: calc(100vh / (949 / 30));
    display: inline-block;
    position: relative;
    /*top: 22px;*/
    top: calc(100vh / (949 / 22));
    /*left: 70px;*/
    left: calc(100vh / (949 / 70));
  }

  .info-box-icon-main {
    stroke: none;
    fill: var(--info-primary-color);
    /*height: 30px;*/
    height: calc(85vh / (949 / 30));
    position: absolute;
    /*top: 22px;*/
    /*top: calc(103px / 2 - (30px / 2));*/
    top: calc(85vh / (949 / 37));
    /*left: 35px;*/
    left: calc(85vh / (949 / 70));
  }

  /* ------------- */

  .error-box, .refuse-box {
    transition: opacity 0.8s ease;
    background: url(/static/images/eror_msg.svg) top center no-repeat;
    width: 667px;
    height: 103px;
    text-align: left;
    position: absolute;
    top: -10000px;
    opacity: 0;
  }

  .error-text, .refuse-text {
    text-align: center;
    color: var(--error-primary-color);
    font-family: 'Open Sans', Arial;
    font-weight: 400;
    font-size: 14px;
    display: inline-block;
    position: relative;
    width: 498px;
    height: 45px;
    top: calc(50% - (45px / 2));
    left: calc(50% - (498px / 2));
  }

  .error-text ul, .error-text ul li, .refuse-text ul, .refuse-text ul li, .warning-text ul, .warning-text ul li {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  .error-box-icon, .refuse-box-icon {
    stroke: none;
    height: 26px;
    width: 26px;
    display: inline-block;
    position: relative;
    top: 23px;
    left: 65px;
    cursor: pointer;
  }

  /* ------------- */

  .warning-box {
    background: url(/static/images/eror_msg.svg) top center no-repeat;
    width: calc(100vh / (949 / 667));
    height: calc(100vh / (949 / 103));
    margin: auto;
    text-align: left;
    position: relative;
    padding-left: calc(100vh / (949 / 55));
  }

  .warning-text ul li {
    text-align: center;
    color: var(--error-primary-color);
    font-family: 'Open Sans', Arial;
    font-weight: 400;
    font-size: calc(100vh / (949 / 14));
    display: table-cell;
    position: relative;
    width: calc(100vh / (949 / 498));
    height: calc(100vh / (949 / 103));
    left: calc(50% - ((100vh / (949 / 498)) / 2));
    vertical-align: middle;
  }

  .warning-box-icon {
    stroke: none;
    height: calc(100vh / (949 / 35));
    width: calc(100vh / (949 / 35));
    float: left;
    position: absolute;
    left: calc(100vh / (949 / (50 + 498 + 15)));
    top: calc(100vh / (949 / 27));
  }

  /* ------------- */

  .modal-title {
    font-family: 'Open Sans', Arial;
    font-weight: 400;
    font-size: 28px;
    color: var(--grey-eighth-color);
  }

  /* ------------- */

  .container.full-width {
    width: 100%;
    margin: initial;
    padding: 0;
    display: flex;
    flex-flow: row wrap;
    height: 100vh;
  }

  .container.full-width > .side-info, .container.full-width > .main {
    height: calc(100vh - 46px);
  }

  .side-info {
    /*background-image: url(/static/images/visuel_boulangerie-light.jpg);*/
    /*background-image: url(/static/images/visuel_tabac-light.jpg);*/
    background-size: cover;
    background-repeat: no-repeat;
    background-position: right 50%;
    position: fixed;
  }

  .side-info p:first-child {
    /*padding-top: 30px;*/
    padding-top: calc(100vh / (949 / 30));
  }

  .side-info > p {
    padding: 0 0 0 30px;
    margin: 0;
    color: var(--secondary-color);
    font-family: 'Open Sans', Arial;
    font-weight: 400;
    /*font-size: 14px;*/
    font-size: calc(100vh / (949 / 16));
    text-align: justify;
    padding-bottom: 25px;
    text-shadow: 1px 1px 3px var(--grey-seventh-color);
  }

  /* ------------- */
  /* ------------- */
  /* ------------- */
  /* ------------- */
  /* ------------- */
  /* ------------- */
  /* ------------- */
  /* ------------- */
  /* ------------- */
  /* ------------- */
  /* ------------- */
  /* ------------- */
  /* ------------- */

  .side-info .btn.btn-default.btn-side-info {
    /*display: table-cell;*/
    /*vertical-align: middle;*/
    border: none;
    font-family: 'Open Sans', Arial;
    font-weight: 600;
    /*font-size: 14px;*/
    font-size: calc(100vh / (949 / 14));
    background-color: var(--primary-color);
    letter-spacing: 1px;
    white-space: normal;
    padding-top: 8px;
    padding-bottom: 8px;
    /*padding-top: 11px;*/
    /*padding-top: calc(100vh / (949 / 16)); */
    margin-left: 30px;
    color: var(--secondary-color);
    border-radius: 5px;
    /*min-height: 36px;*/
    position: relative;
    z-index: 999;
    box-shadow: 0 2px 7px 0.2px rgba(0, 0, 0, 0.3);
    text-decoration: none;
  }

  .side-info .btn.btn-default.btn-side-info:hover {
    background-color: var(--third-color);
  }

  /* ------------- */

  .fil-ariane {
    font-family: 'Open Sans', Arial;
    font-weight: 400;
    font-size: 14px;
    white-space: nowrap;
    color: var(--grey-eighth-color);
  }

  .fil-ariane .parent-items {
    color: var(--grey-third-color);
  }

  .page-title {
    font-family: 'Open Sans', Arial;
    font-weight: 400;
    font-size: 28px;
    color: var(--grey-eighth-color);
    border-bottom: 1px solid var(--grey-primary-color);
    margin-bottom: 0;
    padding-bottom: 12px;
  }

  .hr {
    margin-top: 30px;
    border-top: 1px solid var(--grey-primary-color);
  }

  #diff-en-cours-title {
    color: var(--grey-third-color);
  }

  .main-content {
    text-align: center;
    font-family: 'Open Sans', Arial;
    font-weight: 400;
    font-size: 16px;
    color: var(--grey-eighth-color);
    min-height: calc(100vw + 250px);
  }

  .main-content a {
    color: var(--grey-eighth-color);
    text-decoration: underline;
  }

  .main-content .btn.btn-default.btn-side-info {
    border: none;
    font-family: 'Open Sans', Arial;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 1px;
    white-space: nowrap;
    padding: 8px 20px;
    /*margin-left: 30px;*/
    margin: 0 auto;
    color: var(--secondary-color);
    background-color: var(--primary-color);
    border-radius: 5px;
    width: auto;
    min-height: 36px;
    z-index: 999;
    box-shadow: 0 2px 5px 0.2px rgba(0, 0, 0, 0.25);
    text-decoration: none;
    position: static;
  }

  .main-content .btn.btn-default.btn-side-info:hover {
    background-color: var(--third-color);
  }

  /* ------------- */

  #current-creations {
    /*padding-top: 40px;*/
    padding-top: calc(100vh / (1080 / 40));
  }

  /* ------------- */

  #mentions-holder {
    text-align: right;
  }

  #mentions-legales {
    /*display: block;*/
    margin-top: 7px;
    margin-right: 10px;
  }

  #mentions-legales-label {
    float: right;
  }

  /* ------------- */

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    min-height: 100%;
    width: 100%;
    margin: 0 auto 0 auto;
    position: relative;
    background-color: var(--secondary-color);
  }

  #app.indexBackground {
    /*padding-top: 5%;*/
    /*background-image: url(./assets/images/votre-espace-back-ground-orange.jpg);*/
    /*background-color: var(--primary-color);*/
    background-color: var(--secondary-color);
    /*background-size: cover;*/
    min-width: 100%;
    position: absolute;
  }

  #app.composeMesage {
    padding-top: 15px;
    position: relative;
  }

  .container {
    margin: auto;
    text-align: left;
    padding-bottom: 120px;
  }

  .navbar {
    -ms-transform: rotate(-1.5deg); /* IE 9 */
    -webkit-transform: rotate(-1.5deg); /* Safari */
    transform: rotate(-1.5deg);
    min-height: 170px;
    top: -23px;
    right: -5px;
    width: 5000px;
  }

  .navbar-fixed-top {
    left: auto;
  }

  .navbar > .container {
    -ms-transform: rotate(1.2deg); /* IE 9 */
    -webkit-transform: rotate(1.2deg); /* Safari */
    transform: rotate(1.2deg);
    position: relative;
    top: 65px;
    left: 5px;
    margin: auto;
    padding-bottom: 0;
  }

  .navbar-toggle {
    margin-left: 10px;
  }

  .navbar-inverse .navbar-toggle {
    border-color: var(--green-primary-color);
  }

  .navbar-inverse .navbar-collapse, .navbar-inverse .navbar-form {
    border-color: var(--green-secondary-color);
  }

  .navbar-inverse .navbar-brand, .navbar-inverse .navbar-nav > li > a, .navbar-inverse .navbar-nav > .active > a, .navbar-inverse .navbar-nav > .active > a:hover,
  .navbar-inverse .navbar-nav>.active>a, .navbar-inverse .navbar-nav>.active>a:focus, .navbar-inverse .navbar-nav>.active>a:hover {
    background: inherit;
  }

  .h2-arrow {
    color: var(--fourth-color);
    font: 20px "DINProBold", Arial, Helvetica, sans-serif;
    text-transform: uppercase;
    line-height: 25px;
    padding-left: 1px;
    text-align: left;
    display: inline-block;
    padding-bottom: 25px;
  }

  a.do-not-underline {
    text-decoration: none;
  }

  .h3-sub-title {
    font: 19px "DINProMedium", Arial, Helvetica, sans-serif;
    color: var(--grey-eighth-color);
    line-height: 22px;
    padding: 15px 15px 15px 35px;
    /* background-image: url(./assets/images/bullet-2.png); */
    background-image: url(./assets/images/puce.svg);
    background-repeat: no-repeat;
    background-position: 15px 21px;
    clear: both;
  }

  .h4-sub-title-medium {
    font: 15px "DINProMedium", Arial, Helvetica, sans-serif;
    color: var(--grey-eighth-color);
    line-height: 22px;
    padding: 15px 15px 15px 35px;
    /* background-image: url(./assets/images/bullet.png); */
    background-image: url(./assets/images/puce.svg);
    background-repeat: no-repeat;
    background-position: 15px 21px;
    clear: both;
  }

  .h4-sub-title {
    color: var(--fourth-color);
    font-weight: bold;
    line-height: 22px;
    padding: 15px 15px 15px 35px;
    /* background-image: url(./assets/images/bullet-2.png); */
    background-image: url(./assets/images/puce.svg);
    background-repeat: no-repeat;
    background-position: 15px 19px;
    clear: both;
  }


  .arrow-dark {
    width: 40px;
    height: 40px;
    display: inline-block;
    /* background-image: url(./assets/images/arrow-dark.png); */
    background-image: url(./assets/images/arrow.svg);
    background-color: var(--primary-color);
    background-repeat: no-repeat;
    background-position: center center;
    margin-left: 15px;
  }


  .arrow {
    width: 40px;
    height: 40px;
    display: inline-block;
    /* background-image: url(./assets/images/arrow-medium-2.png); */
    background-image: url(./assets/images/arrow.svg);
    background-color: var(--primary-color);
    background-repeat: no-repeat;
    background-position: center center;
    /* padding: 13px 19px; */
    margin-left: 15px;
  }

  .arrow-reversed {
    width: 40px;
    height: 40px;
    display: inline-block;
    /* background-image: url(./assets/images/arrow-medium-2.png); */
    background-image: url(./assets/images/arrow.svg);
    background-color: var(--primary-color);
    margin-right: 15px;
    -ms-transform: rotate(180deg); /* IE 9 */
    -webkit-transform: rotate(180deg); /* Safari */
    transform: rotate(180deg);
  }

  .orange-list {
    list-style-type: none;
  }

  .orange-list::before {
    content: "";
    display: inline-block;
    width: 5px;
    height: 5px;
    background-color: var(--fourth-color);
    border-radius: 3px;
    margin-right: 5px;
  }

  .green-inverse {
    /*line-height: 22px;
    background: none;*/
    padding-left: 0;
    color: var(--secondary-color);
  }

  .green-inverse li.green-list::before {
    content: "";
    display: inline-block;
    width: 5px;
    height: 5px;
    background-color: var(--secondary-color);
    border-radius: 3px;
    margin-right: 5px;
  }

  .fade-enter-active, .fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }

  .fade-enter-active {
    transition-delay: .25s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  .modal-content {
    border-radius: 0;
  }

  .modal-body {
    padding: 0;
  }

  .modal-body ul {
    margin: 15px 25px;
  }

  .modal-content, div#error-modal-content > ul li{
    text-align: left;
  }

  #current-media img.current-media-vignette {
    width: 350px;
    display: block;
    clear: both;
    margin: 0 0 15px 0;
  }

  .h3-sub-title-no-bullet {
    font: 19px "DINProMedium", Arial, Helvetica, sans-serif;
    color: var(--grey-eighth-color);
    line-height: 22px;
    padding: 0 0 15px 0;
    margin: 0;
    clear: both;
  }

  html body div#app.composeMesage div.container div.col-md-12 div#main-container div#main-text.cke_editable.cke_editable_inline.cke_contents_ltr p {
    /*margin: 0;*/
    /*padding: 0;*/
    /*line-height: normal;*/
    /*color: var(--grey-primary-color);*/
    /*text-size-adjust: none;*/
    /*box-sizing: none;*/
    /*height: 10%;*/
    /*font-size: 11px;*/
  }

  @media (max-width: 1366px) {

    .main {
      width: calc(100% - (30px + 450px));
      margin-right: 30px;
      margin-left: 450px;
    }

    .btn.btn-default.btn-side-info {
      width: 280px;
    }

    .welcome {
      -ms-transform: rotate(1.5deg); /* IE 9 */
      -webkit-transform: rotate(1.5deg); /* Safari */
      transform: rotate(1.5deg);
      font-family: 'Open Sans', Arial;
      font-size: 18px;
      font-weight: 400;
      text-align: left;
      left: calc((5000px - 100vw) + 30px + 82px + 261px);
      position: absolute;
      top: 95px;
    }

    .navbar-logo {
      -ms-transform: rotate(1.5deg);
      -webkit-transform: rotate(1.5deg); 
      transform: rotate(1.5deg);
      max-width: 260px;
      height: auto;
      /* width: 261px;
      height: 46px; */
      left: calc((5000px - 100vw) + 30px);
      position: absolute;
      top: 88px;
    }

    .side-info {
      width: 450px;
    }

    .side-info p {
      width: 310px;
      font-size: calc(100vh / (800 / 16));
    }

    .info-text-main {
    /*width: 667px;*/
    width: calc(85vh / (850 / 667));
    /*height: 113px;*/
    height: calc(85vh / (949 / 113));
    text-align: center;
    color: var(--info-primary-color);
    font-family: 'Open Sans', Arial;
    font-weight: 400;
    /*font-size: 10px;*/
    font-size: calc(85vh / (850 / 16));
    display: table-cell;
    vertical-align: middle;
    }

    .info-text-main-home {
      /*width: 667px;*/
      width: calc(85vh / (850 / 667));
      /*height: 113px;*/
      height: calc(85vh / (949 / 113));
      text-align: center;
      color: var(--info-primary-color);
      font-family: 'Open Sans', Arial;
      font-weight: 400;
      /*font-size: 14px;*/
      font-size: calc(85vh / (850 / 16));
      display: table-cell;
      vertical-align: middle;
      /*padding-left: 45px;*/
      padding-left: calc(85vh / (949 / 45));
    }


    .info-box-icon {
      stroke: none;
      fill: var(--info-primary-color);
      /*height: 30px; */
      height: calc(100vh / (949 / 30));
      display: inline-block;
      position: relative;
      /*top: 22px;*/
      top: calc(100vh / (949 / 22));
      /*left: 70px;*/
      left: calc(100vh / (949 / 70));
    }

    .info-box-icon-main {
      stroke: none;
      fill: var(--info-primary-color);
      /*height: 30px;*/
      height: calc(85vh / (949 / 30));
      position: absolute;
      /*top: 22px;*/
      /*top: calc(103px / 2 - (30px / 2));*/
      top: calc(85vh / (949 / 37));
      /*left: 35px;*/
      left: calc(85vh / (1100 / 70));
    }

}

@media (min-width: 1367px) {

  .current-creations-row {
    /* width: calc(100vw / (1920 / 1028)); */
    /* width: calc(100vw * 0.7); */
    font-size: calc(100vw / (1920 / 50));
  }

  .main {
    width: calc(72% - 30px);
    margin-right: 30px;
    margin-left: 28%;
  }

  .btn.btn-default.btn-side-info {
    width: calc((100vw / (1920 / 350)) - 30px);
  }

  .side-info {
    width: 28%;
  }

  .side-info p {
    width: calc(100vw / (1920 / 350));
  }

  .welcome {
    -ms-transform: rotate(1.5deg); /* IE 9 */
    -webkit-transform: rotate(1.5deg); /* Safari */
    transform: rotate(1.5deg);
    font-family: 'Open Sans', Arial;
    font-size: 22px;
    font-weight: 400;
    text-align: left;
    left: calc((5000px - 100vw) + 30px + 82px + 261px);
    position: absolute;
    top: 80px;
  }

  .navbar-logo {
    -ms-transform: rotate(1.5deg);
    -webkit-transform: rotate(1.5deg); 
    transform: rotate(1.5deg);
    max-width: 260px;
    height: auto;
    /* width: 261px;
    height: 158px; */
    left: calc((5000px - 100vw) + 30px);
    position: absolute;
    top: 80px;
  }

}


</style>



// WEBPACK FOOTER //
// App.vue?35178606